import { Box, Paragraph, VisuallyHidden } from '@zillow/constellation-10';
import { FULLSTORY_EXCLUDE_CLASS_NAME } from '../../constants';
import {
  autoResponseChatBubbleStyles,
  chatBubbleStyles,
  defaultChatBubbleStyles,
  messageOwnerChatBubbleStyles,
} from './styles';

export type ChatBubbleVariant = 'autoResponse' | 'messageOwner' | 'default';

export type ChatBubbleProps = {
  children: React.ReactNode;
  senderName?: string;
  shouldIncludeGutter?: boolean;
  variant: ChatBubbleVariant;
};

export const CHAT_BUBBLE_VARIANT_STYLES = {
  default: defaultChatBubbleStyles,
  autoResponse: autoResponseChatBubbleStyles,
  messageOwner: messageOwnerChatBubbleStyles,
};

export const getScreenReaderSenderName = (variant: ChatBubbleVariant, senderName?: string): string | undefined => {
  if (variant === 'messageOwner') {
    return 'You';
  }

  return variant === 'default' ? senderName : undefined;
};

export default function ChatBubble({ children, senderName, shouldIncludeGutter = false, variant }: ChatBubbleProps) {
  const variantStyles = CHAT_BUBBLE_VARIANT_STYLES[variant];
  const isMessageOwner = variant === 'messageOwner';
  const screenReaderSenderName = getScreenReaderSenderName(variant, senderName);
  const textColor = isMessageOwner ? 'text.onImpact.neutral-fixed' : 'text.neutral';

  return (
    <Box
      data-testid="chat-bubble"
      css={{
        ...chatBubbleStyles,
        ...variantStyles,
        ...(shouldIncludeGutter && {
          marginLeft: isMessageOwner ? 'layout.looser' : '0',
          marginRight: isMessageOwner ? '0' : 'layout.looser',
        }),
      }}
    >
      {!!screenReaderSenderName && (
        <VisuallyHidden className={FULLSTORY_EXCLUDE_CLASS_NAME}>{screenReaderSenderName}</VisuallyHidden>
      )}
      <Paragraph css={{ color: textColor, wordBreak: 'break-word' }}>{children}</Paragraph>
    </Box>
  );
}
